import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, Typography, Paper, IconButton, Grid, TextField, Box } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import emma_w from '../../../../global/imagenes/emma_w.png';
import TareasTerminadas from '../../../general/TareasTerminadas';
import sesionesBienestar from '../../../../global/imagenes/sesionesBienestar.png';
import bienestarFormato from '../../../../global/imagenes/formatosBienestar.png';
import { DetalleAsistencia, DetalleSatisfaccion, DetalleConsentimiento, DetalleConsentimientoCrisis } from '../Bienestar';
import {
    fetchDetalleFormularioSesion,
    fetchFormulariosCompletadosBienestar,
    fetchSesionesBienestar,
} from '../services/bienestarDetalleService';

const CARD_STYLES = {
    card: {
        maxWidth: 280,
        width: '100%',
        height: 170,
        cursor: 'pointer',
        borderRadius: 10,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.12s ease, box-shadow 0.12s ease',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
    },
    cardHeader: { fontSize: '0.9rem', fontWeight: 700, textAlign: 'center', color: '#111', padding: '4px 8px 2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    cardImage: { width: 80, height: 80, objectFit: 'cover', display: 'block', margin: '-6px auto 0' },
    cardDescription: { fontSize: '0.78rem', lineHeight: '1.2', color: '#666', margin: '6px 8px 0px 8px', textAlign: 'center' },
    gridItem: { padding: '6px' },
    container: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, justifyItems: 'center' },
    itemWrapper: { width: '100%', display: 'flex', justifyContent: 'center' },
};

// Función auxiliar para extraer número de sesión
const extraerSesionNumero = (sesion) => {
    if (!sesion) return NaN;
    
    let numero = parseInt(sesion?.valorc || sesion?.valor || sesion?.orden || 0);
    if (numero && !isNaN(numero) && sesion?.valorc !== 'null' && sesion?.valor !== 'null') {
        return numero;
    }
    
    const nombre = (sesion?.nombre || '').toUpperCase();
    
    if (nombre.includes('PRIMERA')) return 1;
    if (nombre.includes('SEGUNDA')) return 2;
    if (nombre.includes('TERCERA')) return 3;
    if (nombre.includes('CUARTA')) return 4;
    if (nombre.includes('QUINTA')) return 5;
    if (nombre.includes('SEXTA')) return 6;
    if (nombre.includes('SÉPTIMA')) return 7;
    if (nombre.includes('OCTAVA')) return 8;
    
    return NaN;
};

const FormatoSesionesDetalle = ({ bienestar_id, tipoFormularioInicial = null, sesionInicial = null, usarTablaDetalleSolicitud = false, resumenBienestar = null, onVolverAtras = null, ocultarHeaderEnDetalle = false }) => {
    const [sesiones, setSesiones] = useState([]);
    const [selectedSesion, setSelectedSesion] = useState(sesionInicial || null);
    const [loading, setLoading] = useState(false);
    const [formulariosCompletados, setFormulariosCompletados] = useState({});
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(tipoFormularioInicial || null);
    const [datosDetalle, setDatosDetalle] = useState(null);
    const [detalleCargado, setDetalleCargado] = useState(false);
    const [cargadoInicial, setCargadoInicial] = useState(false);

    useEffect(() => {
        if (bienestar_id) {
            // Solo cargar formulariosCompletados - las sesiones vendrán del padre si es necesario
            cargarFormulariosCompletados();
        }
    }, [bienestar_id]);
    
    // Si vienen parámetros iniciales, cargar el detalle directamente
    useEffect(() => {
        if (!cargadoInicial && selectedSesion && detalleSeleccionado && Object.keys(formulariosCompletados).length > 0) {
            cargarDetalleFormulario(detalleSeleccionado, selectedSesion);
            setCargadoInicial(true);
        }
    }, [formulariosCompletados]);

    const cargarSesiones = async () => {
        setLoading(true);
        const sesionesResp = await fetchSesionesBienestar(bienestar_id);
        if (Array.isArray(sesionesResp)) {
            setSesiones(sesionesResp);
        }
        setLoading(false);
    };

    const cargarFormulariosCompletados = async () => {
        try {
            const data = await fetchFormulariosCompletadosBienestar(bienestar_id);
            const updates = {};

            const marcar = (lista, key) => {
                if (!Array.isArray(lista)) return;
                lista.forEach(registro => {
                    const sesionNumero = registro.sesion_numero;
                    if (!updates[sesionNumero]) updates[sesionNumero] = {};
                    updates[sesionNumero][key] = true;
                });
            };

            marcar(data?.asistencias, 'asistencia');
            marcar(data?.satisfaccion, 'satisfaccion');
            marcar(data?.consentimientoGeneral, 'consentimientoGeneral');
            marcar(data?.consentimientoCrisis, 'consentimiento_crisis');

            setFormulariosCompletados(prev => {
                const nuevo = { ...prev };
                Object.keys(updates).forEach(sesionNum => {
                    nuevo[sesionNum] = { ...(nuevo[sesionNum] || {}), ...updates[sesionNum] };
                });
                return nuevo;
            });
        } catch (err) {
            console.error('Error cargando formularios:', err);
        }
    };

    const cargarDetalleFormulario = async (tipoFormulario, sesion) => {
        setDetalleSeleccionado(tipoFormulario);
        setDatosDetalle(null);
        setDetalleCargado(false);
        setLoading(true);
        const sesionNumero = extraerSesionNumero(sesion);
        
        if (isNaN(sesionNumero)) {
            setLoading(false);
            return;
        }
        
        const resp = await fetchDetalleFormularioSesion(bienestar_id, tipoFormulario, sesionNumero);
        if (Array.isArray(resp) && resp.length > 0) {
            setDatosDetalle(resp[0]);
            setDetalleSeleccionado(tipoFormulario);
        } else {
            setDatosDetalle(null);
            setDetalleSeleccionado(null);
        }
        setDetalleCargado(true);
        setLoading(false);
    };

    const renderDetalleFormulario = () => {
        if (detalleSeleccionado && (!detalleCargado || loading)) {
            return (
                <TareasTerminadas
                    mensaje={'Cargando detalle'}
                    imagen={emma_w}
                    widthImg={'7%'}
                    cargando={true}
                />
            );
        }

        if (detalleSeleccionado && detalleCargado && !datosDetalle) {
            return (
                <TareasTerminadas
                    mensaje='No hay datos registrados para este formulario'
                    marginTop='7%'
                    imagen={emma_w}
                    widthImg='7%'
                />
            );
        }

        // Modo tabla estilo DetalleSolicitud - usar componentes de Bienestar.js
        if (usarTablaDetalleSolicitud) {
            switch (detalleSeleccionado) {
                case 'asistencia':
                    return <DetalleAsistencia datos={datosDetalle} />;
                case 'satisfaccion':
                    return <DetalleSatisfaccion datos={datosDetalle} />;
                case 'consentimiento':
                    return <DetalleConsentimiento datos={datosDetalle} />;
                case 'consentimiento_crisis':
                    return <DetalleConsentimientoCrisis datos={datosDetalle} />;
                default:
                    return (
                        <Box p={3} textAlign="center">
                            <Typography variant="h6" color="textSecondary">
                                Tipo de formulario no reconocido: {detalleSeleccionado}
                            </Typography>
                        </Box>
                    );
            }
        }

        // Modo tarjetas por defecto
        return (
            <Box p={3}>
                <Grid container spacing={2}>
                    {Object.entries(datosDetalle).map(([key, value]) => {
                        if (key === 'id' || key === 'bienestar_id' || key === 'sesion_numero' || key === 'fecha_creacion') {
                            return null;
                        }
                        
                        let label = key
                            .replace(/_/g, ' ')
                            .split(' ')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');

                        return (
                            <Grid item xs={12} sm={6} key={key}>
                                <TextField
                                    fullWidth
                                    label={label}
                                    value={value || ''}
                                    multiline
                                    rows={value && typeof value === 'string' && value.length > 50 ? 3 : 1}
                                    InputProps={{ readOnly: true }}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        );
    };

    if (selectedSesion && detalleSeleccionado) {
        return (
            <div style={{ position: 'relative', padding: 12 }}>
                {!ocultarHeaderEnDetalle && (
                    <>
                        <div style={{ position: 'absolute', left: 8, top: 8 }}>
                            <IconButton onClick={() => {
                                if (onVolverAtras) {
                                    onVolverAtras();
                                } else {
                                    setDetalleSeleccionado(null);
                                }
                            }}>
                                <ArrowBackIcon />
                            </IconButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                            <Typography variant='h6' style={{ marginLeft: 8 }}>
                                Detalle - {detalleSeleccionado === 'consentimiento_crisis' ? 'Consentimiento Crisis' : detalleSeleccionado.charAt(0).toUpperCase() + detalleSeleccionado.slice(1)}
                            </Typography>
                        </div>
                    </>
                )}
                {loading ? (
                    <TareasTerminadas mensaje={'Cargando detalle'} imagen={emma_w} widthImg={'7%'} cargando={true} />
                ) : (
                    renderDetalleFormulario()
                )}
            </div>
        );
    }

    // Mostrar módulos de sesión cuando hay una sesión seleccionada
    if (selectedSesion) {
        const sesionNumeroCheck = extraerSesionNumero(selectedSesion);
        const formsSesion = formulariosCompletados[sesionNumeroCheck] || {};
        const tieneCrisisCompletado = !!formsSesion.consentimiento_crisis;

        const consentimientoModules = tieneCrisisCompletado
            ? [{ key: 'consentimiento_crisis', title: 'Consentimiento Crisis' }]
            : (selectedSesion.codigo === 'pri_se_bien' ? [{ key: 'consentimiento', title: 'Consentimiento' }] : []);

        const modules = [
            { key: 'asistencia', title: 'Asistencia' },
            ...consentimientoModules,
            { key: 'satisfaccion', title: 'Satisfacción' }
        ];

        return (
            <div style={{ position: 'relative', padding: 12 }}>
                <div style={{ position: 'absolute', left: 8, top: 8 }}>
                    <IconButton onClick={() => setSelectedSesion(null)}>
                        <ArrowBackIcon />
                    </IconButton>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                    <Typography variant='h6' style={{ marginLeft: 8 }}>
                        {selectedSesion.nombre || selectedSesion.valor}
                    </Typography>
                </div>
                <div style={CARD_STYLES.container}>
                    {modules.map(m => {
                        const sesionNumero = extraerSesionNumero(selectedSesion);
                        const formulariosDeEstaSesion = formulariosCompletados[sesionNumero] || {};
                        
                        const isCompleted = 
                            (m.key === 'asistencia' && formulariosDeEstaSesion.asistencia) ||
                            (m.key === 'satisfaccion' && formulariosDeEstaSesion.satisfaccion) ||
                            (m.key === 'consentimiento' && formulariosDeEstaSesion.consentimientoGeneral) ||
                            (m.key === 'consentimiento_crisis' && formulariosDeEstaSesion.consentimiento_crisis);

                        return (
                            <div key={m.key} style={Object.assign({}, CARD_STYLES.itemWrapper, CARD_STYLES.gridItem)}>
                                <Paper style={{ borderRadius: 10, width: '100%' }} elevation={0}>
                                    <Card
                                        style={{
                                            ...CARD_STYLES.card,
                                            cursor: isCompleted ? 'pointer' : 'default',
                                            opacity: 1,
                                        }}
                                        elevation={2}
                                        onClick={() => {
                                            if (isCompleted) {
                                                cargarDetalleFormulario(m.key, selectedSesion);
                                            }
                                        }}
                                        onMouseEnter={e => isCompleted && (e.currentTarget.style.transform = 'translateY(-4px)')}
                                        onMouseLeave={e => isCompleted && (e.currentTarget.style.transform = 'translateY(0)')}
                                    >
                                        <CardHeader title={m.title} titleTypographyProps={{ style: CARD_STYLES.cardHeader }} />
                                        <CardContent style={{ padding: '6px 12px 6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', position: 'relative' }}>
                                            <div style={{ width: '100%', height: 56, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', position: 'relative' }}>
                                                <img src={bienestarFormato} alt={m.title} style={CARD_STYLES.cardImage} />
                                                {isCompleted ? (
                                                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                                                        <CheckCircleIcon style={{ color: '#4CAF50', fontSize: 28 }} />
                                                    </div>
                                                ) : (
                                                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                                                        <Typography variant="caption" style={{ color: '#999' }}>
                                                            Sin datos
                                                        </Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Paper>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // Loader de sesiones sólo si no hay sesión seleccionada
    if (loading && sesiones.length === 0) {
        return (
            <div style={{ padding: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 160 }}>
                <TareasTerminadas mensaje={'Cargando sesiones'} imagen={emma_w} widthImg={'7%'} cargando={true} />
            </div>
        );
    }

    // Mostrar mensaje si no hay sesiones y no hay una sesión seleccionada
    if (!sesiones || sesiones.length === 0) {
        return (
            <div style={{ padding: 24 }}>
                <Typography>No hay sesiones definidas</Typography>
            </div>
        );
    }

    // Mostrar detalle de formulario
    if (selectedSesion && detalleSeleccionado) {
        return (
            <div style={{ position: 'relative', padding: 12 }}>
                <div style={{ position: 'absolute', left: 8, top: 8 }}>
                    <IconButton onClick={() => setDetalleSeleccionado(null)}>
                        <ArrowBackIcon />
                    </IconButton>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                    <Typography variant='h6' style={{ marginLeft: 8 }}>
                        Detalle3 - {detalleSeleccionado === 'consentimiento_crisis' ? 'Consentimiento Crisis' : detalleSeleccionado.charAt(0).toUpperCase() + detalleSeleccionado.slice(1)}
                    </Typography>
                </div>
                {loading ? (
                    <TareasTerminadas mensaje={'Cargando detalle'} imagen={emma_w} widthImg={'7%'} cargando={true} />
                ) : (
                    renderDetalleFormulario()
                )}
            </div>
        );
    }

    // Mostrar módulos de sesión
    if (selectedSesion) {
        const sesionNumeroCheck = extraerSesionNumero(selectedSesion);
        const formsSesion = formulariosCompletados[sesionNumeroCheck] || {};
        const tieneCrisisCompletado = !!formsSesion.consentimiento_crisis;

        const consentimientoModules = tieneCrisisCompletado
            ? [{ key: 'consentimiento_crisis', title: 'Consentimiento Crisis' }]
            : (selectedSesion.codigo === 'pri_se_bien' ? [{ key: 'consentimiento', title: 'Consentimiento' }] : []);

        const modules = [
            { key: 'asistencia', title: 'Asistencia' },
            ...consentimientoModules,
            { key: 'satisfaccion', title: 'Satisfacción' }
        ];

        return (
            <div style={{ position: 'relative', padding: 12 }}>
                <div style={{ position: 'absolute', left: 8, top: 8 }}>
                    <IconButton onClick={() => setSelectedSesion(null)}>
                        <ArrowBackIcon />
                    </IconButton>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                    <Typography variant='h6' style={{ marginLeft: 8 }}>
                        {selectedSesion.nombre || selectedSesion.valor}
                    </Typography>
                </div>
                <div style={CARD_STYLES.container}>
                    {modules.map(m => {
                        const sesionNumero = extraerSesionNumero(selectedSesion);
                        const formulariosDeEstaSesion = formulariosCompletados[sesionNumero] || {};
                        
                        const isCompleted = 
                            (m.key === 'asistencia' && formulariosDeEstaSesion.asistencia) ||
                            (m.key === 'satisfaccion' && formulariosDeEstaSesion.satisfaccion) ||
                            (m.key === 'consentimiento' && formulariosDeEstaSesion.consentimientoGeneral) ||
                            (m.key === 'consentimiento_crisis' && formulariosDeEstaSesion.consentimiento_crisis);

                        return (
                            <div key={m.key} style={Object.assign({}, CARD_STYLES.itemWrapper, CARD_STYLES.gridItem)}>
                                <Paper style={{ borderRadius: 10, width: '100%' }} elevation={0}>
                                    <Card
                                        style={{
                                            ...CARD_STYLES.card,
                                            cursor: isCompleted ? 'pointer' : 'default',
                                            opacity: 1,
                                        }}
                                        elevation={2}
                                        onClick={() => isCompleted && cargarDetalleFormulario(m.key, selectedSesion)}
                                        onMouseEnter={e => isCompleted && (e.currentTarget.style.transform = 'translateY(-4px)')}
                                        onMouseLeave={e => isCompleted && (e.currentTarget.style.transform = 'translateY(0)')}
                                    >
                                        <CardHeader title={m.title} titleTypographyProps={{ style: CARD_STYLES.cardHeader }} />
                                        <CardContent style={{ padding: '6px 12px 6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', position: 'relative' }}>
                                            <div style={{ width: '100%', height: 56, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', position: 'relative' }}>
                                                <img src={bienestarFormato} alt={m.title} style={CARD_STYLES.cardImage} />
                                                {isCompleted ? (
                                                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                                                        <CheckCircleIcon style={{ color: '#4CAF50', fontSize: 28 }} />
                                                    </div>
                                                ) : (
                                                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                                                        <Typography variant="caption" style={{ color: '#999' }}>
                                                            Sin datos
                                                        </Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Paper>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // Mostrar lista de sesiones
    const sesionesOrdenadas = sesiones.slice().sort((a, b) => {
        const getNum = x => {
            if (!x) return NaN;
            if (x.valorc !== undefined && x.valorc !== null && x.valorc !== '') { const n = parseFloat(x.valorc); if (!isNaN(n)) return n; }
            if (x.valor !== undefined && x.valor !== null && x.valor !== '') { const n = parseFloat(x.valor); if (!isNaN(n)) return n; }
            if (x.orden !== undefined && x.orden !== null && x.orden !== '') { const n = parseFloat(x.orden); if (!isNaN(n)) return n; }
            if (x.id !== undefined && x.id !== null && x.id !== '') { const n = parseFloat(x.id); if (!isNaN(n)) return n; }
            return NaN;
        };
        const na = getNum(a);
        const nb = getNum(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        const sa = (a.nombre || a.valor || a.valorc || '').toString().toLowerCase();
        const sb = (b.nombre || b.valor || b.valorc || '').toString().toLowerCase();
        return sa.localeCompare(sb);
    });

    return (
        <div style={CARD_STYLES.container}>
            {sesionesOrdenadas.map((s, i) => {
                const img = s.archivo || s.imagen || s.icono || s.valor || s.url || sesionesBienestar;
                return (
                    <div key={s.id || i} style={Object.assign({}, CARD_STYLES.itemWrapper, CARD_STYLES.gridItem)}>
                        <Paper style={{ borderRadius: 10, width: '100%' }} elevation={0}>
                            <Card
                                style={CARD_STYLES.card}
                                elevation={2}
                                onClick={() => setSelectedSesion(s)}
                                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <CardHeader title={s.nombre || s.valor || `Sesión ${i + 1}`} titleTypographyProps={{ style: CARD_STYLES.cardHeader }} />
                                <CardContent style={{ padding: '6px 12px 6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                                    <div style={{ width: '100%', height: 56, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                                        <img src={img} alt={s.nombre || ''} style={CARD_STYLES.cardImage} />
                                    </div>
                                    {s.descripcion && <Typography variant="body2" style={CARD_STYLES.cardDescription}>{s.descripcion}</Typography>}
                                </CardContent>
                            </Card>
                        </Paper>
                    </div>
                );
            })}
        </div>
    );
};

// Evitar re-montajes innecesarios cuando el padre re-renderiza
export default React.memo(FormatoSesionesDetalle, (prevProps, nextProps) => {
    const noHaCambiado = (
        prevProps.bienestar_id === nextProps.bienestar_id &&
        prevProps.tipoFormularioInicial === nextProps.tipoFormularioInicial &&
        prevProps.sesionInicial?.id === nextProps.sesionInicial?.id
    );

    return noHaCambiado;
});
